import { Slide } from "react-reveal";
import ICTTrainingSolution from "../list/ICTTrainingSolution";
import ICTConsultancySolution from "../list/ICTConsultancySolution";
import ICTSupplySolution from "../list/ICTSupplySolution";
 
const RelatedCCTVSecurity = () => {
  return (
    <section className="related section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center">
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Related Solutions
                </h2>
              </Slide>
            </div>
            <div className="section-body section-spacing-50 no-padding-top">
              <ul className="solutions-items-container">
                <ICTTrainingSolution />
                <ICTConsultancySolution />
                <ICTSupplySolution />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RelatedCCTVSecurity;
